export default [
    <link rel="alternate" hreflang="en-gb" href="https://www.drybarshops.co.uk" />,
    <link rel="alternate" hreflang="en-us" href="https://www.drybarshops.com" />,
    <link rel="alternate" hreflang="x-default" href="https://www.drybarshops.com" />,
];